export type PhaseContractReferencesCopy = {
  title: string
  /** What the reference is called, e.g. "opportunity". */
  entityLabel: string
  emptyText: string
  addLabel: string
}

export const SALESFORCE_OPPORTUNITIES_COPY: PhaseContractReferencesCopy = {
  title: 'Opportunities by phase',
  entityLabel: 'opportunity',
  emptyText: 'No opportunity',
  addLabel: 'Add opportunity'
}

export const NETSUITE_CONTRACT_TAGS_COPY: PhaseContractReferencesCopy = {
  title: 'Contract tags by phase',
  entityLabel: 'contract tag',
  emptyText: 'No contract tag',
  addLabel: 'Add contract tag'
}
